var api = "https://api.qingcigame.com";
var Media = document.getElementById('media-play');
var obj = {
    index: function() {
        $('.index').removeClass('loading');
        this.preloading(); // 预加载
        this.indexSwiper(); // 首页大轮播
        this.indexBind();
        this.share();
    },
    // 图片资源预加载
    preloading: function() {
        //图片预加载
        var queue = new createjs.LoadQueue();
        queue.on("progress", function(e) {
            //加载中的进度
            if (e.progress * 100 >= 10) {
                $(".loding_time p").text(parseInt(e.progress * 100) + '%')
            };
            var numbers = e.progress * 100;
            // console.log(numbers);
        }, this);
        queue.on("complete", function(e) {
            //加载完成执行操作
            $('.loding_time').remove();
            $('.preloading').addClass('preloading-ani').fadeOut(1000);
            $('.float-time').addClass('float-time-ani')
            $('.index').removeClass('loading');
            $('.bg').addClass('bg-ani');

            setTimeout(function() {
                $('.preloading').remove();
            }, 1000);
        }, this);
        queue.loadManifest([
            //加载图片，不包括后台的
            '/half_anniversary/images/pc/content_bg-fefe81bc74.png',
            '/half_anniversary/images/pc/share_pop-24120aa1d5.png',
            '/half_anniversary/images/pc/page_1-cf0dad7ee9.png',
            '/half_anniversary/images/pc/page_1_atmosphere-1a47b985f9.png',
            '/half_anniversary/images/pc/page_1_butterfly-8ff27e8810.png',
            '/half_anniversary/images/pc/page_1_mask-4830342598.png',
        ]);
    },
    // 首页轮播
    indexSwiper: function() {
        var mySwiper = new Swiper('.swiper-container', {
            direction: 'horizontal',
            slidesPerView: 'auto',
            parallax: true,
            followFinger: false,
            speed: 1500,
            touchRatio: .7,
            spaceBetween: 300,
            mousewheelControl: true,
            resistanceRatio: 0,
            mousewheel: {
                thresholdDelta: 110,
            },
            onInit: function(swiper) {
                swiperAnimate(swiper);

                function Ani(btn, page) {
                    $(btn).on('click', function() {
                        mySwiper.slideTo(page, 1500, true);
                        if(page == 0) {
                          $(".index .swiper-container .content_bg").fadeIn();
                        }
                        __bl.sum(`半周年专题页_${['首页', '邂逅国粹', '第二届巅峰联赛', '阴阳·独孤剑圣'][page]}`);
                    });
                }
                var aniLink01 = Ani('.tab_01', '0');
                var aniLink02 = Ani('.tab_02', '1');
                var aniLink03 = Ani('.tab_03', '2');
                var aniLink04 = Ani('.tab_04', '3');

                // 点击弹窗背景关闭弹窗
                $('.mouse, .tab_02').click(function(event) {
                    $(".index .swiper-container .first_bg").addClass("page_bg_ani1").removeClass('page_bg_ani0');
                });
                
            },
            onSlideChangeStart: function(swiper) {
                swiperAnimate(swiper);
                $('.footer').removeClass('footer-on');
                $(".tab_0" + Number(swiper.activeIndex+1) + "").addClass("active").siblings().removeClass("active");

                for (var i = 6; i >= 0; i--) $(".first_bg").removeClass("page_bg_ani"+i+"");
                $(".index .swiper-container .first_bg").addClass("page_bg_ani"+swiper.activeIndex+"");
                
                
            },
            onSlideChangeEnd: function(swiper) {
                swiperAnimate(swiper);
            },
        });
    },

    indexBind: function() {
        // 技能切换
        $('.skill-icon .skill').click(function(event) {
            $(this).addClass('select').siblings()
                .removeClass('select').parent('.skill-icon')
                .siblings('.skill-desc').children('.desc')
                .eq($(this).index()).addClass('show').siblings().removeClass('show');
            __bl.sum(`半周年专题页_剑圣技能${$(this).data('name')}`);
        })

        $('.video-btn').click(function(event) {

            $('.video-wrap').fadeIn();
            Media.play();
            __bl.sum('半周年专题页_视频弹窗');
        });

        $('.close-btn').click(function(event) {
            $('.popup').fadeOut();
            Media.pause();
        });

        // 点击查看页尾
        $('.footer').click(function(event) {
            var _this = $(this);
            _this.hasClass('footer-on') ? _this.removeClass('footer-on') : _this.addClass('footer-on');
        });

        // 点击分享按钮-开启分享弹窗
        $('.share-btn').click(function() {
            $('.share-wrap').fadeIn();
            __bl.sum('半周年专题页_分享弹窗');
        });
        $('.official-btn').click(function() {
            $('.share-wrap').fadeIn();
            __bl.sum('半周年专题页_官网');
        });

        // 关闭分享弹窗
        $('.share-wrap').on('click','.close-btn', function() {
            $('.share-wrap').fadeOut();
        });
        $('.jj_btn').click(function() {
            __bl.sum('半周年专题页_入梦寻仙');
            window.location.href = 'https://hjwq.qingcijoy.com/peking-pera-linkage/index.html';
        });
        $('.details-btn').click(function() {
            __bl.sum('半周年专题页_赛事详情');
            window.location.href = 'https://hjwq.qingcijoy.com/challengeSecSeason/league.html';
        });

        $('.download_box .ios_btn, .download_box .andriod_btn').on('click', function() {
            var className = $(this).attr('class');
            var game_id = 69;
            $.ajax({
                type: "get",
                url: 'https://api.qingcigame.com/get_url?game_id=' + game_id + '',
                dataType: 'json',
                xhrFields: {
                    withCredentials: true
                },
                success: function(json) {
                    // 百度品专 专属下载地址
                    if (className.indexOf('ios_btn') !== -1) {
                        // ios
                        if (json.data.ios_down_url == '' || json.data.ios_down_url == null) {
                            layer.msg('ios下载暂未开放，敬请期待！', { time: 3000 });
                        } else {
                            location.href = json.data.ios_down_url
                        }
                        __bl.sum('半周年专题页_App Store下载');
                    } else {
                        // 安卓
                        if (json.data.android_down_url == '' || json.data.android_down_url == null) {
                            layer.msg('安卓下载暂未开放，敬请期待！', { time: 3000 });
                        } else {
                            location.href = json.data.android_down_url
                        }
                        __bl.sum('半周年专题页_android下载');
                    }
                }
            });
        });

        var clipboard = new Clipboard('.copy-btn');
            clipboard.on('success', function(e) {
            console.info('Action:', e.action);
            console.info('Text:', e.text);
            console.info('Trigger:', e.trigger);
            layer.msg("复制链接,快去分享给好友吧~", { time: 2000 });
            e.clearSelection();
            __bl.sum('半周年专题页_复制链接');
        });

    },
    share: function() {
        
    }
}